
import { Link } from "react-router-dom"

export default function Course1() {
	return (
		<>

			<div className="tf-widget-course main-content">
				<div className="themeflat-container">
					<div className="tf-course">
						{/* header style v1 */}
						<div className="title-box center-title-box title-large">
							<span className="sub-title wow fadeInUp animated">Fanatanjahatenaa</span>
							<h2 className="title-section wow fadeInUp animated">Blaogy Fandriana mlay
								running</h2>
						</div>{/* header style v1 */}
						<div className="row">
							<div className="col-md-4 course">
								<div className="course-item-wrap wow fadeInUp animated">
									<Link to="/blog-single" className="image-course">
										<span className="date-course">21 Oct</span>
										<img src="images/marathon/all-teams.png" alt="" />
									</Link>
									<div className="content-course">
										<div className="meta-course">
											<ul>
												<li>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6710_2624)">
																<path d="M3.96938 13.1725C3.82899 13.032 3.75009 12.8415 3.75 12.6428V3.95312H12.4397C12.6383 3.95322 12.8288 4.03211 12.9694 4.1725L22.2806 13.4838C22.4212 13.6244 22.5001 13.8151 22.5001 14.0139C22.5001 14.2127 22.4212 14.4034 22.2806 14.5441L14.3438 22.4838C14.2031 22.6243 14.0124 22.7032 13.8136 22.7032C13.6148 22.7032 13.4241 22.6243 13.2834 22.4838L3.96938 13.1725Z" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M8.25 8.07812C8.25 8.28523 8.08211 8.45312 7.875 8.45312C7.66789 8.45312 7.5 8.28523 7.5 8.07812C7.5 7.87102 7.66789 7.70312 7.875 7.70312C8.08211 7.70312 8.25 7.87102 8.25 8.07812Z" stroke="#121212" strokeWidth="1.5" />
															</g>
															<defs>
																<clipPath id="clip0_6710_2624">
																	<rect width={24} height={24} fill="white" transform="translate(0 0.203125)" />
																</clipPath>
															</defs>
														</svg>
														5km
													</Link>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6710_2620)">
																<path d="M6.71063 13.7031L3 16.7031V4.70312C3 4.50421 3.07902 4.31345 3.21967 4.1728C3.36032 4.03214 3.55109 3.95312 3.75 3.95313H15.75C15.9489 3.95313 16.1397 4.03214 16.2803 4.1728C16.421 4.31345 16.5 4.50421 16.5 4.70312V12.9531C16.5 13.152 16.421 13.3428 16.2803 13.4835C16.1397 13.6241 15.9489 13.7031 15.75 13.7031H6.71063Z" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M7.5 13.7031V17.4531C7.5 17.652 7.57902 17.8428 7.71967 17.9835C7.86032 18.1241 8.05109 18.2031 8.25 18.2031H17.2894L21 21.2031V9.20312C21 9.00421 20.921 8.81345 20.7803 8.6728C20.6397 8.53214 20.4489 8.45312 20.25 8.45312H16.5" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
															</g>
															<defs>
																<clipPath id="clip0_6710_2620">
																	<rect width={24} height={24} fill="white" transform="translate(0 0.203125)" />
																</clipPath>
															</defs>
														</svg>
													</Link>
												</li>
											</ul>
										</div>
										<h5 className="title-course"><Link to="#">
											Mandraisa ny dia: Famakafakana ireo tombontsoa manova fiainana entin’ny hazakazaka
										</Link></h5>
										<p className="description-course">Fantaro ireo tombontsoa ara-pahasalamana maro atolotry ny hazakazaka, manomboka amin’ny fanatsarana ny fahasalamana ara-pofon’aina sy ny fanamafisana…</p>
									</div>
									<Link to="/blog-single" className="flat-button">Hamaky</Link>
								</div>
							</div>
							<div className="col-md-4 course">
								<div className="course-item-wrap wow fadeInUp animated " data-wow-delay="0.3s">
									<Link to="/blog-single" className="image-course">
										<span className="date-course">14 Oct</span>
										<img src="images/marathon/wa9.jpg" alt="" />
									</Link>
									<div className="content-course">
										<div className="meta-course">
											<ul>
												<li>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6710_2624)">
																<path d="M3.96938 13.1725C3.82899 13.032 3.75009 12.8415 3.75 12.6428V3.95312H12.4397C12.6383 3.95322 12.8288 4.03211 12.9694 4.1725L22.2806 13.4838C22.4212 13.6244 22.5001 13.8151 22.5001 14.0139C22.5001 14.2127 22.4212 14.4034 22.2806 14.5441L14.3438 22.4838C14.2031 22.6243 14.0124 22.7032 13.8136 22.7032C13.6148 22.7032 13.4241 22.6243 13.2834 22.4838L3.96938 13.1725Z" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M8.25 8.07812C8.25 8.28523 8.08211 8.45312 7.875 8.45312C7.66789 8.45312 7.5 8.28523 7.5 8.07812C7.5 7.87102 7.66789 7.70312 7.875 7.70312C8.08211 7.70312 8.25 7.87102 8.25 8.07812Z" stroke="#121212" strokeWidth="1.5" />
															</g>
														</svg>
														15km
													</Link>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6710_2620)">
																<path d="M6.71063 13.7031L3 16.7031V4.70312C3 4.50421 3.07902 4.31345 3.21967 4.1728C3.36032 4.03214 3.55109 3.95312 3.75 3.95313H15.75C15.9489 3.95313 16.1397 4.03214 16.2803 4.1728C16.421 4.31345 16.5 4.50421 16.5 4.70312V12.9531C16.5 13.152 16.421 13.3428 16.2803 13.4835C16.1397 13.6241 15.9489 13.7031 15.75 13.7031H6.71063Z" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M7.5 13.7031V17.4531C7.5 17.652 7.57902 17.8428 7.71967 17.9835C7.86032 18.1241 8.05109 18.2031 8.25 18.2031H17.2894L21 21.2031V9.20312C21 9.00421 20.921 8.81345 20.7803 8.6728C20.6397 8.53214 20.4489 8.45312 20.25 8.45312H16.5" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
															</g>
														</svg>
													</Link>
												</li>
											</ul>
										</div>
										<h5 className="title-course"><Link to="/blog-single">Fampaherezana amin’ny alalan’ny hazakazaka:
											Fahitana ny lakilen’ny fiainana salama sy feno fahasambarana</Link></h5>
										<p className="description-course">Vahao ny fahalalahan’ny saina sy ny vatana rehefa tsapanao ny hafaliana sy ny fanafahana entin’ny hazakazaka. Fantaro ny fomba ahafahan’ny hazakazaka…</p>
									</div>
									<Link to="/blog-single" className="flat-button">Hamaky</Link>
								</div>
							</div>
							<div className="col-md-4 course">
								<div className="course-item-wrap wow fadeInUp animated" data-wow-delay="0.6s">
									<Link to="/blog-single" className="image-course">
										<span className="date-course">25 Oct</span>
										<img src="images/marathon/wa4.jpg" alt="" />
									</Link>
									<div className="content-course">
										<div className="meta-course">
											<ul>
												<li>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6710_2624)">
																<path d="M3.96938 13.1725C3.82899 13.032 3.75009 12.8415 3.75 12.6428V3.95312H12.4397C12.6383 3.95322 12.8288 4.03211 12.9694 4.1725L22.2806 13.4838C22.4212 13.6244 22.5001 13.8151 22.5001 14.0139C22.5001 14.2127 22.4212 14.4034 22.2806 14.5441L14.3438 22.4838C14.2031 22.6243 14.0124 22.7032 13.8136 22.7032C13.6148 22.7032 13.4241 22.6243 13.2834 22.4838L3.96938 13.1725Z" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M8.25 8.07812C8.25 8.28523 8.08211 8.45312 7.875 8.45312C7.66789 8.45312 7.5 8.28523 7.5 8.07812C7.5 7.87102 7.66789 7.70312 7.875 7.70312C8.08211 7.70312 8.25 7.87102 8.25 8.07812Z" stroke="#121212" strokeWidth="1.5" />
															</g>
														</svg>
													</Link>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6710_2620)">
																<path d="M6.71063 13.7031L3 16.7031V4.70312C3 4.50421 3.07902 4.31345 3.21967 4.1728C3.36032 4.03214 3.55109 3.95312 3.75 3.95313H15.75C15.9489 3.95313 16.1397 4.03214 16.2803 4.1728C16.421 4.31345 16.5 4.50421 16.5 4.70312V12.9531C16.5 13.152 16.421 13.3428 16.2803 13.4835C16.1397 13.6241 15.9489 13.7031 15.75 13.7031H6.71063Z" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M7.5 13.7031V17.4531C7.5 17.652 7.57902 17.8428 7.71967 17.9835C7.86032 18.1241 8.05109 18.2031 8.25 18.2031H17.2894L21 21.2031V9.20312C21 9.00421 20.921 8.81345 20.7803 8.6728C20.6397 8.53214 20.4489 8.45312 20.25 8.45312H16.5" stroke="#121212" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
															</g>
														</svg>
													</Link>
												</li>
											</ul>
										</div>
										<h5 className="title-course"><Link to="/blog-single">Mihazakazaka mankany amin’ny fahamboniana:
											Avoahy ny atleta ao anatinao ary raiso ny hafalian’ny fahasalamana ara-batana</Link></h5>
										<p className="description-course">Raiso ny firaisankina sy ny fifanohanana eo anivon’ny vondrom-piarahamonin’ny mpihazakazaka, rehefa mifandray amin’ireo olona mitovy finiavana aminao ianao…</p>
									</div>
									<Link to="/blog-single" className="flat-button">Hamaky</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
